module.exports = __webpack_public_path__ + "static/media/tutorial-5.71c10609.jpg";